module.exports = __webpack_public_path__ + "img/bg-cubic.957d4399.svg";